var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 54,
    viewBox: "0 0 45 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.769 40.27H42.049C42.2632 40.2723 42.4758 40.2321 42.6744 40.1518C42.873 40.0714 43.0538 39.9526 43.2062 39.8021C43.3587 39.6516 43.4798 39.4724 43.5627 39.2748C43.6456 39.0773 43.6885 38.8652 43.689 38.651V10.279C43.6887 10.0648 43.6461 9.85271 43.5635 9.65505C43.4808 9.45738 43.3599 9.27803 43.2076 9.12734C43.0554 8.97664 42.8748 8.85758 42.6762 8.77703C42.4777 8.69648 42.2652 8.65603 42.051 8.65801H22.651C22.3599 8.65696 22.0719 8.59857 21.8033 8.48617C21.5348 8.37378 21.2911 8.20958 21.086 8.00295C20.881 7.79633 20.7187 7.55133 20.6083 7.28196C20.498 7.01258 20.4418 6.7241 20.443 6.43301V2.63801C20.443 2.4224 20.4004 2.20891 20.3177 2.00979C20.2351 1.81066 20.1139 1.62982 19.9611 1.47764C19.8084 1.32546 19.6271 1.20493 19.4277 1.12297C19.2283 1.04101 19.0146 0.999221 18.799 1.00001H2.638C2.20357 1.00001 1.78694 1.17259 1.47976 1.47977C1.17257 1.78695 1 2.20359 1 2.63801V38.651C1.00396 39.0825 1.17841 39.4948 1.48528 39.7981C1.79215 40.1015 2.20653 40.2711 2.638 40.27H13.918",
    stroke: "#14213D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 37.0049V19.2319C1.00565 17.8521 1.55543 16.5298 2.53113 15.5541C3.50683 14.5784 4.82911 14.0286 6.20895 14.0249H38.478C39.8587 14.0273 41.1822 14.5765 42.159 15.5523C43.1358 16.5282 43.6863 17.8512 43.69 19.2319V37.0049",
    stroke: "#14213D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.297 52.0018C22.39 52.0018 15.048 48.2818 14.329 45.0408C13.596 41.7408 13.963 30.1118 13.963 30.1118H30.723C30.723 30.1118 31.089 41.7428 30.357 45.0408C29.639 48.2798 22.297 52.0018 22.39 52.0018",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3701 40.475L20.8881 42.993L26.3171 37.564",
    stroke: "#F88216",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature_5.ecd7c87973567949d6d7d90380c6eb22.svg";
export { ForwardRef as ReactComponent };